<sew-button class="close" hierarchy="tertiary" icon="close" show-icon-only>
    <button (click)="onClose()"></button>
</sew-button>
<div class="content">
    <ng-template [cdkPortalOutlet]="overlayPortal | async"></ng-template>
</div>
